import { API_JWT_TOKEN_NAME, CALL_API } from '../middleware/api'

export const DOCUMENT_NUMBER_SEARCH_REQUEST = 'DOCUMENT_NUMBER_SEARCH_REQUEST'
export const DOCUMENT_NUMBER_SEARCH_SUCCESS = 'DOCUMENT_NUMBER_SEARCH_SUCCESS'
export const DOCUMENT_NUMBER_SEARCH_FAILURE = 'DOCUMENT_NUMBER_SEARCH_FAILURE'
export const DOCUMENT_NUMBER_SEARCH_RESET = 'DOCUMENT_NUMBER_SEARCH_RESET'

export const searchDocumentNumberTransactions = (documentNumber) => ({
  [CALL_API]: {
    endpoint: `/api/document-search/?document_number=${encodeURIComponent(documentNumber)}`,
    types: [DOCUMENT_NUMBER_SEARCH_REQUEST, DOCUMENT_NUMBER_SEARCH_SUCCESS, DOCUMENT_NUMBER_SEARCH_FAILURE],
    method: 'GET',
    tokenType: API_JWT_TOKEN_NAME,
  },
})

const reset = () => ({
  type: DOCUMENT_NUMBER_SEARCH_RESET,
})
export const resetSearchDocumentNumberTransactions = () => (dispatch) => dispatch(reset())
